module.exports = __webpack_public_path__ + "img/warning-tip.a4764489.png";